import { render, staticRenderFns } from "./ClaimTypeForm.vue?vue&type=template&id=7cedc158"
import script from "./ClaimTypeForm.vue?vue&type=script&lang=js"
export * from "./ClaimTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ClaimTypeForm.vue?vue&type=style&index=0&id=7cedc158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports